import React, {Fragment} from 'react';

import PropTypes from 'prop-types';

import {
  GlobalNavMenuDivider,
} from 'static/three-oh/src/components/GlobalLayout/GlobalNav/GlobalNavSearch/JeevesSearchSuggestions/SuggestionParts/SuggestionParts';
import RecentSearches from 'static/three-oh/src/components/SearchOverlay/components/RecentSearches/RecentSearches';
import RecommendedSearches from 'static/three-oh/src/components/SearchOverlay/components/RecommendedSearches/RecommendedSearches';


const propTypes = {
  history: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  userProperties: PropTypes.object.isRequired,
  suggestionsAreActive: PropTypes.bool.isRequired,
  suggestionsAreVisible: PropTypes.bool.isRequired,
  onQueryTermSubmission: PropTypes.func.isRequired,
  throttledQueryTerm: PropTypes.string,
  onSuggestionDismiss: PropTypes.func.isRequired,
  onSuggestionTab: PropTypes.func.isRequired,
  trackUserEvent: PropTypes.func.isRequired,
};


const JeevesSearchSuggestions = (props) => {
  // Handle the display of the "Recent Searches" section.
  const recentSearchTerms = 'recentSearchTerms';
  const recentSearchTermsString = sessionStorage.getItem(recentSearchTerms);
  const noRecentSearchesExist = !recentSearchTermsString || !recentSearchTermsString.length;
  const {isAuthenticated, isStudent} = props.userProperties;
  const displayRecentSearches = isAuthenticated && !isStudent && !noRecentSearchesExist;

  return (
    <>
      {
        !props.suggestionsAreVisible &&
        <RecentSearches
          onQueryTermSubmission={props.onQueryTermSubmission}
          trackUserEvent={props.trackUserEvent}
          userProperties={props.userProperties}
          isGlobalNavSearch
          queryTerm={props.throttledQueryTerm}
          onSuggestionDismiss={props.onSuggestionDismiss}
          onSuggestionTab={props.onSuggestionTab}
        />
      }
      {
        !props.suggestionsAreVisible &&
        displayRecentSearches &&
        <GlobalNavMenuDivider/>
      }
      <RecommendedSearches
        onQueryTermSubmission={props.onQueryTermSubmission}
        trackUserEvent={props.trackUserEvent}
        isGlobalNavSearch
        queryTerm={props.throttledQueryTerm}
        onSuggestionDismiss={props.onSuggestionDismiss}
        onSuggestionTab={props.onSuggestionTab}
      />
    </>
  );
};

JeevesSearchSuggestions.propTypes = propTypes;
export default JeevesSearchSuggestions;
